import { isPreview } from "../helpers/others";
export function animateScroll() {
    if (isPreview())
        return;
    const ANIMATIONS = ['fade', 'slide-up', 'slide-up-sm'];
    const elements = document.querySelectorAll('[data-animate]');
    if (elements.length === 0)
        return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const animation = entry.target.dataset.animate || '';
            if (!ANIMATIONS.includes(animation))
                return;
            if (entry.isIntersecting)
                entry.target.classList.add(`${animation}-animate`);
        });
    });
    elements.forEach((element) => {
        const animation = element.dataset.animate || '';
        if (ANIMATIONS.includes(animation)) {
            observer.observe(element);
        }
    });
}
